import React from 'react';
import { Instagram, MessageCircle, Phone, Send } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-cream py-16" data-id="element-202" data-mp="3gfitaf6445cj">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203" data-mp="32nukolv2nz0b">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-204" data-mp="32pfg0dp7nlz8">
          <div className="col-span-1 md:col-span-2" data-id="element-205" data-mp="36oo5h6d7wxoz">
            <a href="#" className="text-4xl font-serif font-semibold tracking-wide text-brand-cream block mb-6" data-id="element-206" data-mp="36n3bpiyq9is6">
              na.lilu
            </a>
            <p className="text-brand-cream/70 max-w-sm font-light leading-relaxed" data-id="element-207" data-mp="36mrsgl2ksqw">
              Преміальний український бренд жіночого одягу. Елегантність, якість
              та сучасна жіночність у кожній нитці.
            </p>
          </div>

          <div data-id="element-208" data-mp="29yxbr9cr3ek8">
            <h4 className="font-serif text-xl mb-6" data-id="element-209" data-mp="29ydwk0ehj49w">Швидкі посилання</h4>
            <ul className="space-y-3 text-brand-cream/70 font-light" data-id="element-210" data-mp="2eyt9iquuu9rc">
              <li data-id="element-211" data-mp="3l9k4zam1djc8">
                <a href="#catalog" className="hover:text-white transition-colors" data-id="element-212" data-mp="3l90lhpgqmmw3">
                  Каталог
                </a>
              </li>
              <li data-id="element-213" data-mp="3v89d4bo4rpfa">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-214" data-mp="3v8rgds97n3wp">
                  Про нас
                </a>
              </li>
              <li data-id="element-215" data-mp="3qazr75zy9vw7">
                <a href="#reviews" className="hover:text-white transition-colors" data-id="element-216" data-mp="82qsptubnvu9">
                  Відгуки
                </a>
              </li>
              <li data-id="element-217" data-mp="hsk4auugsayi">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-218" data-mp="ht39rc2xh6vn">
                  Контакти
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-219" data-mp="qu1drudd9ee8">
            <h4 className="font-serif text-xl mb-6" data-id="element-220" data-mp="qrfaw81f7n2c">Контакти</h4>
            <ul className="space-y-4 text-brand-cream/70 font-light" data-id="element-221" data-mp="mt7s77necboi">
              <li data-id="element-222" data-mp="tvmqpiubmimf">
                <a href="tel:+380964797313" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-223" data-mp="tw5w602sbejk">
                  <Phone className="w-4 h-4" data-id="element-224" data-mp="13tkc7yksq1bc" />
                  +380 96 479 7313
                </a>
              </li>
              <li data-id="element-225" data-mp="18k93pdwh6yah">
                <a href="viber://chat?number=%2B380964797313" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-226" data-mp="18ksn6z1rxuqm">
                  <MessageCircle className="w-4 h-4" data-id="element-227" data-mp="1hjnvcgodpewk" />
                  Viber
                </a>
              </li>
              <li data-id="element-228" data-mp="1mkbk0vp4xjnm">
                <a href="https://t.me/+380964797313" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-229" data-mp="1mhpc2uyc124v">
                  <Send className="w-4 h-4" data-id="element-230" data-mp="3tb9ljoisvnt8" />
                  Telegram
                </a>
              </li>
              <li data-id="element-231" data-mp="2afx31156yb6i">
                <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-232" data-mp="2ageulkgws183">
                  <Instagram className="w-4 h-4" data-id="element-233" data-mp="1woi9i0dnqrl7" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-brand-cream/50 font-light" data-id="element-234" data-mp="2pcectnxqfhqy">
          <p data-id="element-235" data-mp="2kbqcucrizqkl">&copy; {new Date().getFullYear()} na.lilu. Всі права захищені.</p>
          <div className="flex gap-6" data-id="element-236" data-mp="2fd5bga0jf0uk">
            <a href="#" className="hover:text-white transition-colors" data-id="element-237" data-mp="2fgayljplvsnn">
              Політика конфіденційності
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-238" data-mp="13zb7grezvjv7">
              Умови надання послуг
            </a>
          </div>
        </div>
      </div>
    </footer>;
}